export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.iconContainer)+'"></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/interaction-indicator/templates/container.dot
// module id = 139
// module chunks = 0 1 2 3 4